import { ChangeDetectorRef, Directive, inject, Input, OnInit, ViewChild } from "@angular/core";
import { CdkPortalOutlet } from "@angular/cdk/portal";
import { CdkDropList } from "@angular/cdk/drag-drop";

import { IPEmailBuilderUiService } from "../services";
import { IP_EMAIL_BUILDER_BLOCKS_DATA } from "../private-tokens";
import { TStructureTypes } from "../interfaces";
import { IStructure, Structure } from "../structure/structure";
import { AIPEmailBuilderBlockExtendedOptions } from "./Block";
import { TemplateService } from "../services/template.service";

/**
 * Abstract class for settings portal.
 * Component' HTML that extends this class, must contain {@link CdkPortalOutlet} directive.
 *
 * @example
 * <ng-container [cdkPortalOutlet]="activeSettings$ | async"></ng-container>
 */
@Directive()
export abstract class AIPEmailBuilderAside implements OnInit {
  // Mark all settings as readonly.
  @Input() readonly = false;
  snippetList: any = [];
  page: number = 1;
  pageSize: number = 6;
  totalRecords: number = 0;

  // Portal Outlet where settings portal must be attached.
  @ViewChild(CdkPortalOutlet, { static: true })
  readonly asideSettingsPortal?: CdkPortalOutlet;

  // Reference for the snippets drop list in the template
  @ViewChild("snippetsDropList", { static: true })
  snippetsDropListRef?: CdkDropList<any>;
  // A list of DnD blocks.
  readonly blocks = inject(IP_EMAIL_BUILDER_BLOCKS_DATA);
  readonly customBlocks = inject(IP_EMAIL_BUILDER_BLOCKS_DATA);

  // Add a new list for snippets.
  readonly snippets = [
    { title: "Snippet 1", id: "snp_1" },
    { title: "Snippet 2", id: "snp_2" },
    { title: "Snippet 3", id: "snp_3" },
  ];
  // A list of DnD structures.
  readonly structures = (
    [
      "cols_1",
      "cols_2",
      "cols_12",
      "cols_21",
      "cols_3",
      "cols_4",
      "cols_5",
      "cols_6",
    ] as TStructureTypes[]
  ).map((type) => new Structure(type));
  readonly builderUiService = inject(IPEmailBuilderUiService);
  // Current active portal settings.
  // readonly activeSettings$ = this.builderUiService.currentSettingsPortal$;
  // Columns list where DnD blocks can be dragged.
  get columnsDropLists(): CdkDropList<AIPEmailBuilderBlockExtendedOptions[]>[] {
    return Array.from(this.builderUiService.columnsDropLists);
  }
  get customColumnsDropLists(): CdkDropList<
    AIPEmailBuilderBlockExtendedOptions[]
  >[] {
    return Array.from(this.builderUiService.columnsDropLists);
  }

  // Structures list where DnD structures can be dragged.
  get structuresDropLists(): CdkDropList<IStructure[]>[] {
    return Array.from(this.builderUiService.structuresDropLists);
  }

  get snippetsDropLists(): CdkDropList<any[]>[] {
    return Array.from(this.builderUiService.snippetsDropLists);
  }
  constructor(private apiService: TemplateService,private cdRef: ChangeDetectorRef) {
    this.getAllSnippetlist();
  }
  ngOnInit() {
    if (this.asideSettingsPortal) {
      this.builderUiService.setSettingsPortalOutlet(this.asideSettingsPortal);
    } else {
      console.warn(
        `You must add [cdkPortalOutlet]="activeSettings$ | async" to aside component HTML.`
      );
    }
  }
  // After View Init lifecycle hook to register the snippets drop list.
  ngAfterViewInit() {
    if (this.snippetsDropListRef) {
      this.builderUiService.snippetsDropLists.add(this.snippetsDropListRef);
    }
  }
  getAllSnippetlist(): void {
    let data = {
      pageNumber: this.page,
      pageSize: this.pageSize,
    };
    this.apiService.getAllSnippetList(data).subscribe((res) => {
      if (res.isSuccess) {
        this.snippetList = res?.response;
        this.totalRecords = res?.totalRecords;
        this.cdRef.detectChanges();
      } else {
        this.snippetList = [];
      }
    });
  }
}
